import React from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Target, Users, Sparkles, TrendingUp } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            AIMERKUR Hakkında
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            E-ticaret dünyasında yapay zeka ile yeni bir çağ başlatıyoruz
          </p>
        </div>

        {/* Main Content */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Biz Kimiz?</h2>
            <p className="text-gray-600 mb-4">
              AIMERKUR, e-ticaret satıcılarının müşteri sorularını yapay zeka ile otomatik olarak 
              yanıtlamasını sağlayan yenilikçi bir platformdur. <span className="font-semibold text-[#FF6000]">Admosphere</span> ailesinin 
              bir parçası olarak, ticaretin dijital dönüşümünde öncü rol oynuyoruz.
            </p>
            <p className="text-gray-600 mb-4">
              Adımız, yapay zeka (AI) ve ticaretin Roma tanrısı Merkür'ün birleşiminden gelmektedir. 
              Merkür, ticaret, iletişim ve hızın sembolüdür - tam da platformumuzun sunduğu değerler.
            </p>
            <p className="text-gray-600">
              Ana şirketimiz <span className="font-semibold text-[#FF6000]">Admosphere</span> ise reklam 
              ve dijital pazarlama atmosferinde faaliyet gösteren, teknoloji odaklı bir şirkettir.
            </p>
          </div>
          
          <div className="space-y-6">
            <Card>
              <CardContent className="p-6">
                <Target className="h-12 w-12 text-[#FF6000] mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">Misyonumuz</h3>
                <p className="text-gray-600">
                  E-ticaret satıcılarının müşteri hizmetlerini otomatikleştirerek, 
                  daha fazla satış ve müşteri memnuniyeti sağlamalarına yardımcı olmak.
                </p>
              </CardContent>
            </Card>
            
            <Card>
              <CardContent className="p-6">
                <Sparkles className="h-12 w-12 text-[#FF6000] mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">Vizyonumuz</h3>
                <p className="text-gray-600">
                  Türkiye'nin ve bölgenin en büyük AI destekli e-ticaret çözüm platformu olmak.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Values */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Değerlerimiz</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <Card>
              <CardContent className="p-6 text-center">
                <TrendingUp className="h-12 w-12 text-[#FF6000] mx-auto mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">İnovasyon</h3>
                <p className="text-gray-600">
                  Sürekli gelişim ve yenilikçi çözümlerle sektörde öncü olmak
                </p>
              </CardContent>
            </Card>
            
            <Card>
              <CardContent className="p-6 text-center">
                <Users className="h-12 w-12 text-[#FF6000] mx-auto mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">Müşteri Odaklılık</h3>
                <p className="text-gray-600">
                  Müşterilerimizin başarısı bizim başarımız
                </p>
              </CardContent>
            </Card>
            
            <Card>
              <CardContent className="p-6 text-center">
                <Sparkles className="h-12 w-12 text-[#FF6000] mx-auto mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">Kalite</h3>
                <p className="text-gray-600">
                  Her zaman en yüksek standartlarda hizmet sunmak
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Admosphere Partnership */}
        <Card className="bg-gradient-to-r from-orange-50 to-orange-100 border-orange-200">
          <CardContent className="p-8">
            <div className="text-center max-w-3xl mx-auto">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Admosphere İştiraki
              </h2>
              <p className="text-gray-700">
                AIMERKUR, <span className="font-semibold text-[#FF6000]">Admosphere</span> şirketler 
                grubunun bir parçasıdır. Admosphere, dijital reklam ve pazarlama teknolojileri alanında 
                faaliyet gösteren, yenilikçi çözümler sunan bir teknoloji şirketidir. Grup şirketlerimiz 
                ile birlikte, e-ticaret ekosisteminde kapsamlı çözümler sunuyoruz.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <Footer />
    </div>
  );
}
